/**
 * Decides whether the "Importuj z pliku" catalog affordance should be shown.
 *
 * The import button is a standalone-catalog-only action. When the catalog is
 * opened in "add media units to an offer" context (navigated to from an
 * offer's Nośniki tab via "Dodaj nośniki", i.e. `addToOfferId` present in the
 * URL search), the button must stay hidden regardless of import permission —
 * see CU-86cak2294.
 */
export function resolveCanImport(
  hasImportPermission: boolean,
  addToOfferId: string | undefined,
): boolean {
  return hasImportPermission && !addToOfferId;
}
